import { JSX } from 'react';

export type PhraseFieldSectionProps = {
  sectionTitle: string;
  sectionDescription?: string;
  sectionDescriptionVisible?: boolean;
  sectionClassName?: string;
  renderHeaderItem?: () => JSX.Element;
  renderSectionContents?: () => JSX.Element;
};

export function PhraseFieldSection({
  sectionTitle,
  sectionDescription,
  sectionDescriptionVisible,
  sectionClassName,
  renderHeaderItem,
  renderSectionContents,
}: PhraseFieldSectionProps) {
  return (
    <div className={sectionClassName}>
      <div className={`border-2 border-solid rounded p-4`}>
        <div className='flex items-center justify-between'>
          <h3 className='text-2xl font-bold'>{sectionTitle}</h3>
          {renderHeaderItem ? renderHeaderItem() : null}
        </div>
        <div className='grid gap-4 grid-cols-1'>
          {sectionDescriptionVisible ? (
            <p className='pb-4 text-sm text-gray-500 mt-2'>
              {sectionDescription}
            </p>
          ) : null}
          {renderSectionContents ? renderSectionContents() : null}
        </div>
      </div>
    </div>
  );
}
